<template>
    <vx-modal :visible="visible" @update:visible="visible = false" class="vx-max-w-lg" :padding="false">
        <div class="vx-flex vx-flex-col vx-text-center vx-gap-3 vx-py-24 vx-px-12">
            <font-awesome-icon :class="color" size="xl" :icon="faTriangleExclamation"></font-awesome-icon>
            <span class="vx-text-3xl vx-font-extrabold vx-text-black vx-leading-9">{{ props.title }}</span>
            <span v-if="props.message" class="vx-text-base vx-font-normal vx-text-black">{{ props.message }}</span>
        </div>

        <template v-slot:footer>
            <div class="vx-flex vx-flex-col-reverse vx-gap-4 lg:vx-flex-row">
                <vx-button v-if="cancelBtn"
                    @click.prevent="visible = false"
                    type="button"
                    class="vx-grow lg:vx-w-20 lg:vx-grow-0"
                    size="lg"
                    color="muted">
                    {{ cancelText }}
                </vx-button>
                <vx-button @click.prevent="emit('confirm')"
                    data-test="confirm-button"
                    type="button"
                    class="vx-grow"
                    size="lg"
                    color="primary">
                    {{ props.confirmText }}
                </vx-button>
            </div>
        </template>
    </vx-modal>
</template>

<script setup>
import { VxButton, VxModal } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { computed } from 'vue';

const emit = defineEmits(['confirm']);

const visible = defineModel('visible', {
    type: Boolean,
    default: false,
});

const props = defineProps({
    confirmText: {
        type: String,
        default: 'Confirm'
    },
    cancelText: {
        type: String,
        default: 'Cancel'
    },
    cancelBtn: {
        type: Boolean,
        default: true
    },
    message: {
        type: String,
    },
    title: {
        type: String,
        default: 'Are you sure?'
    },
    type: {
        type: String,
    }
});

const color = computed(() => props.type === 'danger' ? 'vx-text-rose-500' : 'vx-text-amber-400');
</script>
